import Cookies from "js-cookie";

export const getImageUrlWithExpiry = (url: string) => {
  if (!url) return "";
  const expiry = setAndGetExpiry();
  return url + "?cache_bust=" + expiry;
};

export const setAndGetExpiry = () => {
  let isCookieSet = false;
  if (!Cookies.get("iet")) {
    const date = new Date();
    date.setDate(date.getDate() + 7);
    Cookies.set("iet", date.getTime().toString());
    isCookieSet = true;
  }
  if (
    !isCookieSet &&
    Cookies.get("iet") &&
    new Date(Number(Cookies.get("iet"))).getTime() < new Date().getTime()
  ) {
    const date = new Date();
    date.setDate(date.getDate() + 7);
    Cookies.set("iet", date.getTime().toString());
  }
  return Cookies.get("iet");
};
